import firebase from "firebase/app";
import "firebase/auth";

const emailAuth = async (
  email: string,
  password: string,
  rememberMe?: boolean
) => {
  try {
    const auth = firebase.auth();
    await auth.setPersistence(
      rememberMe
        ? firebase.auth.Auth.Persistence.LOCAL
        : firebase.auth.Auth.Persistence.SESSION
    );
    await auth.signInWithEmailAndPassword(email, password);
    return { success: true };
  } catch (error) {
    const { code, message } = error;
    console.log(error);
    switch (code) {
      case "auth/email-already-in-use":
        return {
          success: false,
          code,
          message: "This email is already in use",
        };
      case "auth/user-not-found":
        return { success: false, code, message: "Invalid Email Address" };
      case "auth/invalid-email":
        return { success: false, code, message: "Invalid Email Address" };
      case "auth/wrong-password":
        return {
          success: false,
          code,
          message:
            "The email/password is invalid or you had signed up via Google",
        };
      default:
        return { success: false, code, message };
    }
  }
};

export default emailAuth;
